export const MP_CUSTOMER_SERVICES_TEL = "01332 426 351";
export const OBSERVER_PIXEL_CONTENT_HOST = "827E87A08564463282491DD8FB0A78DB92650594";
export const OBSERVER_PIXEL_APPLICTION_NAME = "motorpoint.co.uk";
export const PINNED_ARTICLES_COUNT = 3;
export const PRESS_PINNED_ARTICLES_COUNT = 2;
export const BLOG_POSTS_PER_PAGE = 12;
export const PRESS_POSTS_PER_PAGE = 8;
export const POSTS_PER_TOPIC_PAGE = 12;
export const ARTICLES_PER_AUTHOR_PAGE = 12;
export const REVIEWS_PER_PAGE = 12;
export const BLOG_INDEX_POSTS_ON_PAGE = BLOG_POSTS_PER_PAGE - PINNED_ARTICLES_COUNT - 1;
export const PRESS_INDEX_POSTS_ON_PAGE = PRESS_POSTS_PER_PAGE - PRESS_PINNED_ARTICLES_COUNT - 1;
export const DEFAULT_IMAGE_URL =
    "https://assets.motorpoint.co.uk/vehicle-advert/image-coming-soon/1024.jpg";
export const DEFAULT_COMINGSOON_IMAGE_URL =
    "https://assets.motorpoint.co.uk/vehicle-advert/coming-soon/default/1024.jpg";
export const BLOG_SECTION = "blog";
export const BEST_SECTION = "best";
export const NEWS_SECTION = "news";
export const GUIDES_SECTION = "guides";
export const COOKIE_YES_ID = "038b1153c65c24e262591a73";
export const AB_TASTY_ID = "3667be5ad1c9548db908a8b5fb196019";
export const REVALIDATION_TOKEN = "63c40dc3-46ad-4a6d-a7cb-79e2da451a19";
export const PREVIEW_MODE_TOKEN = "129650cc-770a-11ee-b962-0242ac120002";
export const DEFAULT_DEPOSIT_PERCENTAGE = 20;
export const DEFAULT_DEPOSIT_PERCENTAGE_DECIMAL = DEFAULT_DEPOSIT_PERCENTAGE / 100;
export const UK_VAT_RATE_AS_DECIMAL = 0.2;

export enum Categories {
    BLOG_SECTION = "blog",
    BEST_SECTION = "best",
    NEWS_SECTION = "news",
    GUIDES_SECTION = "guides",
    EVENTS_SECTION = "events",
    COMPANY_NEWS = "company_news",
    CAR_NEWS = "car_news",
    COMPARISONS = "comparisons",
}

export const REVALIDATE_SECONDS = {
    DEFAULT: 3600,
    SHORTLIST: 3600,
    BLOG: 3600,
    REVIEWS: 3600,
};

export const EMAIL_REGEX =
    /^[\w!#$%&'*+\/=?^_`{|}~-]+(?:\.[\w!#$%&'*+\/=?^_`{|}~-]+)*@(?:[\w](?:[\w]*[\w])?\.)+[\w](?:[\w]*[\w])?$/;
export const ALPHADIGITS_REGEX = "^([a-zA-Z0-9 ])+$";
export const DIGITS_REGEX = "^\\d+$";
export const TEXT_EXCLUDING_HTML_TAGS_REGEX =
    /<\/?\w+((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/g;
export const PHONE_REGEX = /^(\s*[0-9]+\s*)+$/; // only numbers and whitespace
export const PHONE_NUMBER_REGEX = "^[0-9+]*$";
export const PHONE_AND_MOBILE_REGEX = /^(0\d{10,12}|(\+447)\d{9,10})$/;
export const NUMERICAL_REGEX = /^\d*\.?\d{0,2}$/;

export type CONTENT_PROJECTS = "Motorpoint" | "PartExchange" | "BusinessSettings" | "SharedContent";
export const CONTENT_MANAGER_PROJECT_IDS: Record<CONTENT_PROJECTS, string> = {
    Motorpoint: "fb793c58-315a-0196-d3af-7c9c2613d52c",
    PartExchange: "8c36dddb-b82a-0089-c820-25f0dc1f9b19",
    BusinessSettings: "57c1b0db-3d48-0152-a146-9a5bc6c9a3f3",
    SharedContent: "ac2f7aba-4412-002b-cbd8-267a7e80705b",
};

export const RECENTLY_VIEWED_MAX_VEHICLES = 25;
export const RECENTLY_VIEWED_EXPIRY_DAYS = 30;
export const RECENTLY_VIEWED_COOKIE_NAME = "_rvVehicles";
export const POSTCODE_COOKIE_NAME = "postcodeCapture";

// Sell Your Car Constants
export const SELL_YOUR_CAR_COOKIE_NAME = "SellYourCarAppraisalId";
export const SELL_YOUR_CAR_BASE_URL = "/sell-my-car";
export const SELL_YOUR_CAR_INITIAL_VALUATION_URL =
    SELL_YOUR_CAR_BASE_URL + "/initial-valuation-returning";
export const SELL_YOUR_CAR_BOOK_URL = SELL_YOUR_CAR_BASE_URL + "/start-booking-appointment";
export const SELL_YOUR_CAR_SESSION_STORAGE_KEY = "TempSYCRegistration";

export const ONLINE_STORE_SITE_ID = 501;

export const DEFAULT_TEL_NUMBER = "01332 227 227";

export const MAX_API_VEHICLES = 100;

// General contact form constants
export const ENQUIRY_CONTACT_TYPE = "contactus-general";
export const ENQUIRY_SOURCE = "motorpoint.co.uk";

// Observer Id
export const OBSERVERID_COOKIE_NAME = "UID";

export const SHARE_PRICE_URL =
    "https://motorpoint2024eutfm.q4web.com/feed/StockQuote.svc/GetFullStockQuoteList?apiKey=BF185719B0464B3CB809D23926182246&exchange=XLON&symbol=MOTR";

export const INVESTOR_ANNOUNCEMENTS_URL =
    "https://ir.q4europe.com/ServiceEngine/api/json/reply/RequestNews?lcid=1033&pageNo=0&maxRows=3&headlinesOnly=true&instrumentID=1000702&apiVersion=1&solutionID=2472&customerKey=Motorpointplc";
